import React from 'react';
import { observer } from 'mobx-react';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { Header } from 'libs/rendering/components/header';
import { PlanMonitor } from 'apps/initiative/views/PlanMonitor';
import DocumentHead from 'legacyComponents/documentHead';
import { QuoteList } from '../QuoteList';

export const QuoteListPage = observer(() => {
  const title = 'My Quotes';
  return (
    <PlanMonitor>
      <Header />
      <DocumentHead title={title} />
      <MainWrapper>
        <QuoteList />
      </MainWrapper>
    </PlanMonitor>
  );
});
